import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    $localEncrypt: window.localStorage.localEncrypt||'',
    $aesKey: "385f33cb91484b04", // AES加密密匙
    $aesIv: "37fa77f6a3b0462d", // AES加密密匙的偏移量
    $localDecrypt:  window.localStorage.localDecrypt||'',
  },
  mutations: {
    localEncrypt(state, val) {
      state.$localEncrypt = val;
    },
    localDecrypt(state, val) {
      state.$localDecrypt = val;
    },
  },
  actions: {
    localEncrypt(context, val) {
      context.commit("localEncrypt", val);
    },
    localDecrypt(context, val) {
      context.commit("localDecrypt", val);
    },
  },
});

export default store;
